import React from 'react';
import PropTypes from 'prop-types';
import { Button, Row, Col, FormGroup, Label, Input } from 'reactstrap';
import { classes } from './styles/create';
import { translate } from 'react-i18next';

class CreateUserView extends React.Component {

  render() {
    const {
      t,
      userName,
      firstName,
      lastName,
      password,
      passwordRepeated,
      onUserName,
      onFirstName,
      onLastName,
      onPassword,
      onPasswordRepeated,
      disabled,
      onSave,
      onCancel,
      canSave
    } = this.props;
    const getFieldProps = (value, fn) => ({
      value: value || '',
      onChange: (event) => fn(event.target.value)
    });
    return (
      <React.Fragment>
        <div className={classes.childContainer}>
          <div className={classes.titleContainer}>
            <h6 className={classes.title}>{t('create.title')}</h6>
          </div>
          <Row>
            <Col md={4}>
              <FormGroup>
                <Label for="create_firstName">{t('create.firstNameLabel')}</Label>
                <Input
                  name="create_firstName"
                  id="create_firstName"
                  placeholder={t('create.firstNamePlaceholder')}
                  disabled={disabled}
                  {...getFieldProps(firstName, onFirstName)}
                />
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Label for="create_lastName">{t('create.lastNameLabel')}</Label>
                <Input
                  name="create_lastName"
                  id="create_lastName"
                  placeholder={t('create.lastNamePlaceholder')}
                  disabled={disabled}
                  {...getFieldProps(lastName, onLastName)}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <FormGroup>
                <Label for="create_userName">{t('create.userNameLabel')}</Label>
                <Input
                  name="create_userName"
                  id="create_userName"
                  placeholder={t('create.userNamePlaceholder')}
                  disabled={disabled}
                  {...getFieldProps(userName, onUserName)}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <FormGroup>
                <Label for="create_password">{t('create.passwordLabel')}</Label>
                <Input
                  type="password"
                  name="create_password"
                  id="create_password"
                  placeholder={t('create.passwordPlaceholder')}
                  disabled={disabled}
                  {...getFieldProps(password, onPassword)}
                />
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Label for="create_passwordRepeated">{t('create.passwordRepeatedLabel')}</Label>
                <Input
                  type="password"
                  name="create_passwordRepeated"
                  id="create_passwordRepeated"
                  placeholder={t('create.passwordRepeatedPlaceholder')}
                  disabled={disabled}
                  {...getFieldProps(passwordRepeated, onPasswordRepeated)}
                />
              </FormGroup>
            </Col>
          </Row>
        </div>
        <div className={classes.actionsContainer}>
          <Button
            color="primary"
            size="sm"
            disabled={!canSave || disabled}
            onClick={onSave}
          >
            {t('create.saveAction')}
          </Button>
          <Button
            color="danger"
            size="sm"
            disabled={disabled}
            onClick={onCancel}
          >
            {t('create.cancelAction')}
          </Button>
        </div>
      </React.Fragment>
    )
  }
}

CreateUserView.propTypes = {
  userName: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
  passwordRepeated: PropTypes.string.isRequired,
  onUserName: PropTypes.func.isRequired,
  onFirstName: PropTypes.func.isRequired,
  onLastName: PropTypes.func.isRequired,
  onPassword: PropTypes.func.isRequired,
  onPasswordRepeated: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  canSave: PropTypes.bool.isRequired
};

export default translate(['user'], { wait: true })(CreateUserView);


// WEBPACK FOOTER //
// ./src/views/user/create.js